/* Kyaro goodiebag V6 core. Load with `defer`, BEFORE goodiebag-cal.js (cal also works without it).
   Provides: window.KyaroGB.{$, $$, personal, reveal}, html.js-gb, scroll reveal, personal text swap.
   Personal data: only textContent, never innerHTML. Idempotent; safe to include from every section. */
(function () {
  'use strict';
  var G = window.KyaroGB = window.KyaroGB && typeof window.KyaroGB === 'object' ? window.KyaroGB : {};
  if (G.core) return;
  G.core = 1;

  var d = document, html = d.documentElement;

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  G.$ = $;
  G.$$ = $$;

  /* Personal QR data: window.KyaroGBP = {f, p, a} | null (set by the early inline parser in the hero).
     Elements with a non-empty data-gb-p="... [voornaam] ..." get that text with the first name filled
     in; without a name they get back their generic text. Empty data-gb-p is skipped entirely.
     data-gb-pk hides the element while its text is blank.
     data-gb-max="N": names longer than N characters fall back to the generic text.
     data-gb-upper: the name is upper-cased before substitution. */
  function personal(root) {
    var g = window.KyaroGBP;
    if (!g || typeof g !== 'object') g = null;
    $$('[data-gb-p]', root).forEach(function (el) {
      var p = el.getAttribute('data-gb-p');
      if (!p) return;
      if (el.gbG == null) el.gbG = el.textContent;
      var f = g && g.f, mx = +el.getAttribute('data-gb-max');
      if (f && mx && f.length > mx) f = ''; // too long for its slot (stamp ring): generic text
      if (f && el.hasAttribute('data-gb-upper')) f = f.toUpperCase(); // the name only, not the rest
      var t = f ? p.split('[voornaam]').join(f) : el.gbG;
      if (el.textContent !== t) el.textContent = t;
      if (el.hasAttribute('data-gb-pk')) el.hidden = !t.trim();
    });
  }
  G.personal = personal;

  /* Reveal: .gb-reveal blocks fade in once (CSS keys on html.gb-motion and .is-in). Blocks within
     1.5 viewports of the top, or holding a focus target, are shown at once. Without
     IntersectionObserver, reduced motion or in the theme editor nothing is hidden at all. */
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  function reveal(root) {
    var mo = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || mo || (window.Shopify && Shopify.designMode)) {
      $$('.gb-reveal', root).forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var lim = innerHeight * 1.5, io = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); }
      });
    }, { rootMargin: '0px 0px 25% 0px' });
    $$('.gb-reveal:not(.is-in)', root).forEach(function (el) {
      if (seen) { if (seen.has(el)) return; seen.add(el); }
      if (el.querySelector('[data-gb-focus], [data-gb-bye]') || el.getBoundingClientRect().top < lim) {
        el.classList.add('is-in');
        return;
      }
      el.style.setProperty('--gb-i', Math.min([].indexOf.call(el.parentNode.children, el), 3));
      io.observe(el);
    });
    html.classList.add('gb-motion');
  }
  G.reveal = reveal;

  html.classList.add('js-gb');
  personal();
  reveal();
  d.addEventListener('shopify:section:load', function (e) { personal(e.target); reveal(e.target); });
})();
